export enum FooterItemType {
  link = 'link',
  button = 'button',
}

export interface Link {
  type: FooterItemType.link;
  text: string;
  to: string;
}

export interface Button {
  type: FooterItemType.button;
  text: string;
}

export const items: Array<Link | Button> = [
  {
    type: FooterItemType.button,
    text: 'TERMS OF USE',
  },
  {
    type: FooterItemType.link,
    text: 'PRIVACY',
    to: 'https://cengage.com.au/privacycentre',
  },
  {
    type: FooterItemType.link,
    text: 'COPYRIGHT',
    to: 'https://cengage.com.au/copyright',
  },
  {
    type: FooterItemType.link,
    text: 'DISCLAIMER',
    to: 'https://cengage.com.au/disclaimer',
  },
  {
    type: FooterItemType.link,
    text: 'Contact Us',
    to: 'https://cengage.com.au/contact-us',
  },
];

export const copyright = 'https://cengage.com.au/';
